<template>
    <div class="frame">
        <div class="row q-mb-md">
            <div class="col-12 text-center">
                <!-- {{ $t('cant_watch_the_content_click') }} <a :href="activity.scorm_url" target="_blank">{{ $t('here') }}</a>. -->
                <q-btn dense :label="$t('cant_watch_click_here')" icon="far fa-eye" color="primary" type="a" target="_blank" :href="this.activity.scorm_url" class="link-scorm" />
            </div>
        </div>

        <iframe class="iframe" :src='activity.scorm_url' allow="autoplay; fullscreen" frameBorder="0"></iframe>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['activity'],

    data() {
        return {
            id_course: '',
            id_trail: '',
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        sendPosition() {
            let fd = new FormData()
            fd.append('id_group_training_module', this.activity.type_id)

            let url = ''
            if (this.id_trail == "") {
                url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
            }
            else {
                url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
            }

            this.$axios.post(url, fd, this.getHeader)
            .then(response => {

            })
            .catch(e => {
                console.log(e)
            })
        }
    },

    created() {
        if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if( this.$route.params.id) this.id_course = this.$route.params.id
        this.sendPosition()
    }
}
</script>

<style lang="stylus" scoped>
.frame
    & iframe
        width 100%
        height 75vh
</style>